import Pago from './Pago';
export default Pago;